import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './style/util.scss'
import './style/typography.css'
import './style/layout.scss'
import './style/horizontal.scss'
import './style/recent.scss'
import './style/grid.scss'
import './style/info.scss'
import './style/lightbox.scss'
import './style/suites.scss'
import './style/nav.scss'
import './style/images.scss'
import './style/darkMode.scss'

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
